export const TaskPriority = {
    'dc.FileHarvester': 0,
    'dc.BinaryFileHarvester': 0,
    'dc.ApiHarvester': 0,
    'dc.DataMapper': 1,
};
